import axios from "axios";
import { toast } from "react-toastify";

const ConsentService = {
  create: async (consent) => {
    const token = localStorage.getItem("user-token");

    var data = JSON.stringify(consent);

    var config = {
      method: "post",
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_DELEND_API+"/orders",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config)
      .then(function (response) {
        toast(
          `Requisição para pedido de consentimento para consulta Open Finance criado com sucesso.`
        );
        return response;
      })
      .catch(function (error) {
        toast.error(error.response.data.errorDescription);
        return error.response.status;
      });
  },
};

export default ConsentService;
